<div id="advertisement-dialog">
    <div id="dialog-title" mat-dialog-title>
        <span id="dialog-header">Events & Training</span>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>
    <mat-dialog-content class="modern-content">
        <div class="position-relative">
            <div class="carousel">

                <div class="nav prev" (click)="move(-1)">‹</div>

                <div class="cards">
                    <div *ngFor="let card of cards; let i = index" class="card" [ngClass]="getPosition(i)"
                        (click)="goToNavigate(i)">
                        <img src="{{card.image}}" alt="{{ card.title }}" class="card-img">
                    </div>
                </div>

                <div class="nav next" (click)="move(1)">›</div>

                <div class="dots">
                    <div *ngFor="let card of cards; let i = index" class="dot" [class.active]="i === current"
                        (click)="getTo(i)">
                    </div>
                </div>

                <div class="counter">
                    {{ current + 1 | number:'2.0' }} / {{ total | number:'2.0' }}
                </div>
            </div>
            <div class="text-center">
                <a class="navigate" (click)="navigate()">View More</a>
            </div>
        </div>
    </mat-dialog-content>
</div>